import { useCallback, useMemo } from "react";
import { useToolbar } from "./useToolbar.js";
function noop() {
}
function useToolbarView(props) {
  const { value, onOpen = noop } = props;
  const { activeView, meta, setActiveView, setMetaTarget, width } = useToolbar();
  const isOpen = value === activeView;
  const handleClose = useCallback(() => {
    setActiveView(null);
    setMetaTarget(void 0);
  }, [setActiveView, setMetaTarget]);
  const railPosition = useMemo(() => {
    if (!meta.rail) {
      return null;
    }
    return meta.rail.getBoundingClientRect?.();
  }, [meta]);
  return {
    handleClose,
    handleOpen: onOpen,
    isOpen,
    target: meta.target,
    railWidth: width,
    railPosition
  };
}
export {
  useToolbarView
};
//# sourceMappingURL=useToolbarView.js.map
